export default {
  storeNamespace: 'shipping',
  authFeature: 'shipping',
  listRouteName: "ShippingMobileList",
  fields: [{
      name: 'shipping_date',
      label: "Date d'expédition",
      type: 'date',
      inForm: true,
      requiredCondition: (form) => form.status_slug != 'shipping-en-preparation',
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'shipper_id',
      label: "Transporteur",
      type: 'select',
      inForm: true,
      requiredCondition: (form) => form.status_slug != 'shipping-en-preparation',
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'tracking_number',
      label: "Numéro de suivi",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'weight',
      label: "Poids",
      type: 'number',
      step: 0.01,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value + 'Kg' : null
    },
    {
      name: 'weight',
      label: "Poids (Kg)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
    },
    {
      name: 'handling_unit',
      label: "Nombre d'unités de manutention",
      type: 'number',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'imputation_number',
      label: "Numéro d'imputation",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'comment',
      label: "remarques",
      type: 'textarea',
      inForm: true,
      required: false,
      inList: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ShippingMobile/config.js